import React from 'react';
import { Icon, Modal } from 'semantic-ui-react';
import PJModal from '../componentsHelpers/Modal';
import { patchInitialCheck } from '../api/request';

class OnfidoInitialCheck extends React.Component<any, any> {

  state = { modalOpen: false, modalSize: 'mini', modalContent: null }

  showModal = (modalSize: any) => () => this.setState({ modalSize, modalOpen: true });

  closeModal = () => this.setState({ modalOpen: false, modalContent: null });

  componentDidMount = () => {
    this.onFidoInitialCheck()
      .then((response: any) => {
        if (response.data === 'consider') {
          return this.props.manualStep(9);
        } else if (response.data === 'clear') {
          return this.props.manualStep('ADDITIONAL_QUESTIONS_SELECTOR');
        } else {
          return this.props.manualStep(0);
        }
      })
      .catch((error) => {
        return this.props.manualStep(0);
      });
  }

  onFidoInitialCheck = () => {
    return new Promise((resolve, reject) => {
      this.setState({ modalOpen: true, modalContent: this.modalContent('Identity Check', 'Please wait while we perform a quick identity check', true) });
      patchInitialCheck(this.props.leadId)().then((response) => {
        if (response) {
          //this.setState({ modalOpen: false, modalContent: null });
          resolve(response);
        }
      }).catch(error => {
        if (error) {
          //this.setState({ modalOpen: false, modalContent: null });
          reject(error);
        }
      });
    });
  };

  modalContent = (title: string, msg?: string, spinner?: boolean) => {
    return (
      <React.Fragment>
        <Modal.Header style={{ textAlign: 'center' }}>{title}</Modal.Header>
        <Modal.Content style={{ textAlign: 'center' }}>
          {spinner ? <Icon loading name='spinner' size='massive' /> : null}
          <br />
          {msg ? <p>{msg}</p> : null}
        </Modal.Content>
      </React.Fragment>
    );
  }

  render() {
    return (
      <React.Fragment>
        <PJModal
          size={this.state.modalSize}
          open={this.state.modalOpen}
          content={this.state.modalContent}
        />
      </React.Fragment>
    );
  }
}

export default OnfidoInitialCheck;